import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import Thumbnail from "./Thumbnail";
import NoThumbnail from "./NoThumbnail";
import Slider from "react-slick";
import PropTypes from "prop-types";
import emptySneakerImg from "../../../../images/emptysneakers2.png";
import emptyApparelImg from "../../../../images/emptyapparels.png";
import emptyHandbagImg from "../../../../images/emptyhandbags.png";
import { getCacheImage } from "../../../../config";
import { getCloudImageUrl, emptyImage } from "../../../../utils";

export default class Thumbnails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: this.props.active
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.active !== this.state.active &&
      nextProps.active !== this.props.active
    ) {
      this.setState({ active: nextProps.active }, () =>
        this.refs.slider.slickGoTo(this.state.active)
      );
    }
  }

  render() {
    if (this.props.thumbnails.length === 0)
      return (
        <NoThumbnail src={emptyImage(this.props.category)} alt="No Image.." />
      );
    return (
      <Slider
        ref="slider"
        {...this.props.settings}
        dots={
          this.props.settings.dots
            ? this.props.thumbnails.length > 1
              ? this.props.settings.dots
              : false
            : false
        }
        arrows={
          this.props.settings.arrows
            ? this.props.thumbnails.length > this.props.lengthShow
              ? this.props.settings.arrows
              : false
            : false
        }
        autoplay={
          this.props.settings.autoplay
            ? this.props.thumbnails.length > 1
              ? this.props.settings.autoplay
              : false
            : false
        }
        afterChange={this.props.afterChange}
        beforeChange={this.props.beforeChange}
      >
        {this.props.renderItems
          ? this.props.renderItems(this.props.thumbnails)
          : this.props.thumbnails.map((item, index) => (
              <Thumbnail
                src={getCloudImageUrl(item.URL, 500)}
                key={index}
                alt={`${item.signed_url}`}
                category={this.props.category}
              />
            ))}
      </Slider>
    );
  }
}
Thumbnails.propTypes = {
  thumbnails: PropTypes.array,
  caption: PropTypes.string
};
Thumbnails.defaultProps = {
  thumbnails: [],
  caption: "",
  lengthShow: 3,
  category: "sneakers"
};
